import React, { useState } from "react";
import EquipoModeloService from "../../services/ListaVerificacion/EquipoModeloService";
import { IResponsePost } from "../../Interfaces/base/IResponse";
import { useBoolean } from "@fluentui/react-hooks";

export const useEquipoModeloCrear = () => {
  const [response, setResponse] = useState<IResponsePost>(null!);
  const [isSend, { setTrue: onEnviar, setFalse: onCancelar }] =
    useBoolean(false);

  const postCrearEquipoModelo = (request: any) => {
    ocultarMensaje();
    onEnviar();
    EquipoModeloService.PostCrearEquipoModelo(request)
      .then((res) => {
        if (res.status === 200) {
          setResponse({
            codigoMensaje: res.data.codigoMensaje,
            mensaje: res.data.mensaje,
          });
          onCancelar();
        }
      })
      .catch((e: Error) => {
        onCancelar();
      });
  };
  const ocultarMensaje = () => {
    setResponse(null!);
  };
  return {
    ocultarMensaje,
    response,
    isSend,
    postCrearEquipoModelo,
  };
};
